
// 2 miles = 16 furlongs
// 2.5 miles = 20 furlongs
// 3 miles = 24 furlongs

var wfaJump = {
  "16": {
    "3": {
      "Jan": {
        "1-15": "0",
        "16-31": "0"
      },
      "Feb": {
        "1-15": "0",
        "16-31": "0"
      },
      "Mar": {
        "1-15": "0",
        "16-31": "0"
      },
      "Apr": {
        "1-15": "0",
        "16-31": "0"
      },
      "May": {
        "1-15": "22",
        "16-31": "22"
      },
      "Jun": {
        "1-15": "21",
        "16-31": "21"
      },
      "Jul": {
        "1-15": "20",
        "16-31": "20"
      },
      "Aug": {
        "1-15": "19",
        "16-31": "19"
      },
      "Sep": {
        "1-15": "18",
        "16-31": "18"
      },
      "Oct": {
        "1-15": "17",
        "16-31": "17"
      },
      "Nov": {
        "1-15": "16",
        "16-31": "15"
      },
      "Dec": {
        "1-15": "14",
        "16-31": "13"
      }
    },
    "4": {
      "Jan": {
        "1-15": "12",
        "16-31": "11"
      },
      "Feb": {
        "1-15": "10",
        "16-31": "9"
      },
      "Mar": {
        "1-15": "8",
        "16-31": "7"
      },
      "Apr": {
        "1-15": "6",
        "16-31": "5"
      },
      "May": {
        "1-15": "4",
        "16-31": "4"
      },
      "Jun": {
        "1-15": "3",
        "16-31": "3"
      },
      "Jul": {
        "1-15": "2",
        "16-31": "2"
      },
      "Aug": {
        "1-15": "1",
        "16-31": "1"
      },
      "Sep": {
        "1-15": "0",
        "16-31": "0"
      },
      "Oct": {
        "1-15": "0",
        "16-31": "0"
      },
      "Nov": {
        "1-15": "0",
        "16-31": "0"
      },
      "Dec": {
        "1-15": "0",
        "16-31": "0"
      }
    }
  },
  "20": {
    "3": {
      "Jan": {
        "1-15": "0",
        "16-31": "0"
      },
      "Feb": {
        "1-15": "0",
        "16-31": "0"
      },
      "Mar": {
        "1-15": "0",
        "16-31": "0"
      },
      "Apr": {
        "1-15": "0",
        "16-31": "0"
      },
      "May": {
        "1-15": "23",
        "16-31": "23"
      },
      "Jun": {
        "1-15": "22",
        "16-31": "22"
      },
      "Jul": {
        "1-15": "21",
        "16-31": "21"
      },
      "Aug": {
        "1-15": "20",
        "16-31": "20"
      },
      "Sep": {
        "1-15": "19",
        "16-31": "19"
      },
      "Oct": {
        "1-15": "18",
        "16-31": "19"
      },
      "Nov": {
        "1-15": "17",
        "16-31": "16"
      },
      "Dec": {
        "1-15": "15",
        "16-31": "14"
      }
    },
    "4": {
      "Jan": {
        "1-15": "13",
        "16-31": "12"
      },
      "Feb": {
        "1-15": "11",
        "16-31": "10"
      },
      "Mar": {
        "1-15": "9",
        "16-31": "8"
      },
      "Apr": {
        "1-15": "7",
        "16-31": "6"
      },
      "May": {
        "1-15": "5",
        "16-31": "5"
      },
      "Jun": {
        "1-15": "4",
        "16-31": "4"
      },
      "Jul": {
        "1-15": "3",
        "16-31": "3"
      },
      "Aug": {
        "1-15": "2",
        "16-31": "2"
      },
      "Sep": {
        "1-15": "1",
        "16-31": "1"
      },
      "Oct": {
        "1-15": "0",
        "16-31": "0"
      },
      "Nov": {
        "1-15": "0",
        "16-31": "0"
      },
      "Dec": {
        "1-15": "0",
        "16-31": "0"
      }
    }
  },
  "24": {
    "3": {
      "Jan": {
        "1-15": "0",
        "16-31": "0"
      },
      "Feb": {
        "1-15": "0",
        "16-31": "0"
      },
      "Mar": {
        "1-15": "0",
        "16-31": "0"
      },
      "Apr": {
        "1-15": "0",
        "16-31": "0"
      },
      "May": {
        "1-15": "24",
        "16-31": "24"
      },
      "Jun": {
        "1-15": "23",
        "16-31": "23"
      },
      "Jul": {
        "1-15": "22",
        "16-31": "22"
      },
      "Aug": {
        "1-15": "21",
        "16-31": "21"
      },
      "Sep": {
        "1-15": "20",
        "16-31": "20"
      },
      "Oct": {
        "1-15": "19",
        "16-31": "19"
      },
      "Nov": {
        "1-15": "18",
        "16-31": "17"
      },
      "Dec": {
        "1-15": "16",
        "16-31": "15"
      }
    },
    "4": {
      "Jan": {
        "1-15": "14",
        "16-31": "13"
      },
      "Feb": {
        "1-15": "12",
        "16-31": "11"
      },
      "Mar": {
        "1-15": "10",
        "16-31": "9"
      },
      "Apr": {
        "1-15": "8",
        "16-31": "7"
      },
      "May": {
        "1-15": "6",
        "16-31": "6"
      },
      "Jun": {
        "1-15": "5",
        "16-31": "5"
      },
      "Jul": {
        "1-15": "4",
        "16-31": "4"
      },
      "Aug": {
        "1-15": "3",
        "16-31": "3"
      },
      "Sep": {
        "1-15": "2",
        "16-31": "2"
      },
      "Oct": {
        "1-15": "1",
        "16-31": "1"
      },
      "Nov": {
        "1-15": "0",
        "16-31": "0"
      },
      "Dec": {
        "1-15": "0",
        "16-31": "0"
      }
    }
  }
}

var wfaFlat = {
  "5": {
    "2": {
      "Jan": {
        "1-15": "0",
        "16-31": "0"
      },
      "Feb": {
        "1-15": "0",
        "16-31": "0"
      },
      "Mar": {
        "1-15": "0",
        "16-31": "47"
      },
      "Apr": {
        "1-15": "44",
        "16-31": "41"
      },
      "May": {
        "1-15": "38",
        "16-31": "36"
      },
      "Jun": {
        "1-15": "34",
        "16-31": "32"
      },
      "Jul": {
        "1-15": "30",
        "16-31": "28"
      },
      "Aug": {
        "1-15": "26",
        "16-31": "24"
      },
      "Sep": {
        "1-15": "22",
        "16-31": "20"
      },
      "Oct": {
        "1-15": "19",
        "16-31": "18"
      },
      "Nov": {
        "1-15": "17",
        "16-31": "17"
      },
      "Dec": {
        "1-15": "16",
        "16-31": "16"
      }
    },
    "3": {
      "Jan": {
        "1-15": "15",
        "16-31": "15"
      },
      "Feb": {
        "1-15": "14",
        "16-31": "14"
      },
      "Mar": {
        "1-15": "13",
        "16-31": "12"
      },
      "Apr": {
        "1-15": "11",
        "16-31": "10"
      },
      "May": {
        "1-15": "9",
        "16-31": "8"
      },
      "Jun": {
        "1-15": "7",
        "16-31": "6"
      },
      "Jul": {
        "1-15": "5",
        "16-31": "4"
      },
      "Aug": {
        "1-15": "3",
        "16-31": "2"
      },
      "Sep": {
        "1-15": "1",
        "16-31": "1"
      },
      "Oct": {
        "1-15": "0",
        "16-31": "0"
      },
      "Nov": {
        "1-15": "0",
        "16-31": "0"
      },
      "Dec": {
        "1-15": "0",
        "16-31": "0"
      }
    }
  },
  "6": {
    "2": {
      "Jan": {
        "1-15": "0",
        "16-31": "0"
      },
      "Feb": {
        "1-15": "0",
        "16-31": "0"
      },
      "Mar": {
        "1-15": "0",
        "16-31": "0"
      },
      "Apr": {
        "1-15": "0",
        "16-31": "0"
      },
      "May": {
        "1-15": "44",
        "16-31": "41"
      },
      "Jun": {
        "1-15": "38",
        "16-31": "36"
      },
      "Jul": {
        "1-15": "33",
        "16-31": "31"
      },
      "Aug": {
        "1-15": "28",
        "16-31": "26"
      },
      "Sep": {
        "1-15": "24",
        "16-31": "22"
      },
      "Oct": {
        "1-15": "21",
        "16-31": "20"
      },
      "Nov": {
        "1-15": "19",
        "16-31": "18"
      },
      "Dec": {
        "1-15": "17",
        "16-31": "17"
      }
    },
    "3": {
      "Jan": {
        "1-15": "16",
        "16-31": "16"
      },
      "Feb": {
        "1-15": "15",
        "16-31": "15"
      },
      "Mar": {
        "1-15": "14",
        "16-31": "13"
      },
      "Apr": {
        "1-15": "12",
        "16-31": "11"
      },
      "May": {
        "1-15": "10",
        "16-31": "9"
      },
      "Jun": {
        "1-15": "8",
        "16-31": "7"
      },
      "Jul": {
        "1-15": "6",
        "16-31": "5"
      },
      "Aug": {
        "1-15": "4",
        "16-31": "3"
      },
      "Sep": {
        "1-15": "2",
        "16-31": "2"
      },
      "Oct": {
        "1-15": "1",
        "16-31": "1"
      },
      "Nov": {
        "1-15": "0",
        "16-31": "0"
      },
      "Dec": {
        "1-15": "0",
        "16-31": "0"
      }
    }
  },
  "7": {
    "2": {
      "Jan": {
        "1-15": "0",
        "16-31": "0"
      },
      "Feb": {
        "1-15": "0",
        "16-31": "0"
      },
      "Mar": {
        "1-15": "0",
        "16-31": "0"
      },
      "Apr": {
        "1-15": "0",
        "16-31": "0"
      },
      "May": {
        "1-15": "0",
        "16-31": "0"
      },
      "Jun": {
        "1-15": "0",
        "16-31": "0"
      },
      "Jul": {
        "1-15": "38",
        "16-31": "35"
      },
      "Aug": {
        "1-15": "32",
        "16-31": "30"
      },
      "Sep": {
        "1-15": "27",
        "16-31": "25"
      },
      "Oct": {
        "1-15": "23",
        "16-31": "22"
      },
      "Nov": {
        "1-15": "21",
        "16-31": "20"
      },
      "Dec": {
        "1-15": "19",
        "16-31": "19"
      }
    },
    "3": {
      "Jan": {
        "1-15": "18",
        "16-31": "18"
      },
      "Feb": {
        "1-15": "17",
        "16-31": "17"
      },
      "Mar": {
        "1-15": "16",
        "16-31": "15"
      },
      "Apr": {
        "1-15": "14",
        "16-31": "13"
      },
      "May": {
        "1-15": "12",
        "16-31": "11"
      },
      "Jun": {
        "1-15": "10",
        "16-31": "9"
      },
      "Jul": {
        "1-15": "8",
        "16-31": "7"
      },
      "Aug": {
        "1-15": "6",
        "16-31": "5"
      },
      "Sep": {
        "1-15": "4",
        "16-31": "3"
      },
      "Oct": {
        "1-15": "2",
        "16-31": "2"
      },
      "Nov": {
        "1-15": "1",
        "16-31": "1"
      },
      "Dec": {
        "1-15": "0",
        "16-31": "0"
      }
    }
  },
  "8": {
    "2": {
      "Jan": {
        "1-15": "0",
        "16-31": "0"
      },
      "Feb": {
        "1-15": "0",
        "16-31": "0"
      },
      "Mar": {
        "1-15": "0",
        "16-31": "0"
      },
      "Apr": {
        "1-15": "0",
        "16-31": "0"
      },
      "May": {
        "1-15": "0",
        "16-31": "0"
      },
      "Jun": {
        "1-15": "0",
        "16-31": "0"
      },
      "Jul": {
        "1-15": "0",
        "16-31": "0"
      },
      "Aug": {
        "1-15": "37",
        "16-31": "34"
      },
      "Sep": {
        "1-15": "31",
        "16-31": "28"
      },
      "Oct": {
        "1-15": "26",
        "16-31": "24"
      },
      "Nov": {
        "1-15": "23",
        "16-31": "22"
      },
      "Dec": {
        "1-15": "21",
        "16-31": "20"
      }
    },
    "3": {
      "Jan": {
        "1-15": "20",
        "16-31": "20"
      },
      "Feb": {
        "1-15": "19",
        "16-31": "19"
      },
      "Mar": {
        "1-15": "18",
        "16-31": "17"
      },
      "Apr": {
        "1-15": "15",
        "16-31": "14"
      },
      "May": {
        "1-15": "13",
        "16-31": "12"
      },
      "Jun": {
        "1-15": "11",
        "16-31": "10"
      },
      "Jul": {
        "1-15": "9",
        "16-31": "8"
      },
      "Aug": {
        "1-15": "7",
        "16-31": "6"
      },
      "Sep": {
        "1-15": "5",
        "16-31": "4"
      },
      "Oct": {
        "1-15": "3",
        "16-31": "3"
      },
      "Nov": {
        "1-15": "2",
        "16-31": "2"
      },
      "Dec": {
        "1-15": "1",
        "16-31": "1"
      }
    }
  },
  "9": {
    "3": {
      "Jan": {
        "1-15": "22",
        "16-31": "22"
      },
      "Feb": {
        "1-15": "21",
        "16-31": "21"
      },
      "Mar": {
        "1-15": "20",
        "16-31": "19"
      },
      "Apr": {
        "1-15": "17",
        "16-31": "15"
      },
      "May": {
        "1-15": "14",
        "16-31": "13"
      },
      "Jun": {
        "1-15": "12",
        "16-31": "11"
      },
      "Jul": {
        "1-15": "10",
        "16-31": "9"
      },
      "Aug": {
        "1-15": "8",
        "16-31": "7"
      },
      "Sep": {
        "1-15": "6",
        "16-31": "5"
      },
      "Oct": {
        "1-15": "4",
        "16-31": "4"
      },
      "Nov": {
        "1-15": "3",
        "16-31": "3"
      },
      "Dec": {
        "1-15": "2",
        "16-31": "2"
      }
    },
    "4": {
      "Jan": {
        "1-15": "1",
        "16-31": "1"
      },
      "Feb": {
        "1-15": "0",
        "16-31": "0"
      },
      "Mar": {
        "1-15": "0",
        "16-31": "0"
      },
      "Apr": {
        "1-15": "0",
        "16-31": "0"
      },
      "May": {
        "1-15": "0",
        "16-31": "0"
      },
      "Jun": {
        "1-15": "0",
        "16-31": "0"
      },
      "Jul": {
        "1-15": "0",
        "16-31": "0"
      },
      "Aug": {
        "1-15": "0",
        "16-31": "0"
      },
      "Sep": {
        "1-15": "0",
        "16-31": "0"
      },
      "Oct": {
        "1-15": "0",
        "16-31": "0"
      },
      "Nov": {
        "1-15": "0",
        "16-31": "0"
      },
      "Dec": {
        "1-15": "0",
        "16-31": "0"
      }
    }
  },
  "10": {
    "3": {
      "Jan": {
        "1-15": "23",
        "16-31": "23"
      },
      "Feb": {
        "1-15": "22",
        "16-31": "22"
      },
      "Mar": {
        "1-15": "21",
        "16-31": "20"
      },
      "Apr": {
        "1-15": "19",
        "16-31": "17"
      },
      "May": {
        "1-15": "15",
        "16-31": "14"
      },
      "Jun": {
        "1-15": "13",
        "16-31": "12"
      },
      "Jul": {
        "1-15": "10",
        "16-31": "9"
      },
      "Aug": {
        "1-15": "8",
        "16-31": "7"
      },
      "Sep": {
        "1-15": "6",
        "16-31": "5"
      },
      "Oct": {
        "1-15": "4",
        "16-31": "4"
      },
      "Nov": {
        "1-15": "3",
        "16-31": "3"
      },
      "Dec": {
        "1-15": "2",
        "16-31": "2"
      }
    },
    "4": {
      "Jan": {
        "1-15": "1",
        "16-31": "1"
      },
      "Feb": {
        "1-15": "0",
        "16-31": "0"
      },
      "Mar": {
        "1-15": "0",
        "16-31": "0"
      },
      "Apr": {
        "1-15": "0",
        "16-31": "0"
      },
      "May": {
        "1-15": "0",
        "16-31": "0"
      },
      "Jun": {
        "1-15": "0",
        "16-31": "0"
      },
      "Jul": {
        "1-15": "0",
        "16-31": "0"
      },
      "Aug": {
        "1-15": "0",
        "16-31": "0"
      },
      "Sep": {
        "1-15": "0",
        "16-31": "0"
      },
      "Oct": {
        "1-15": "0",
        "16-31": "0"
      },
      "Nov": {
        "1-15": "0",
        "16-31": "0"
      },
      "Dec": {
        "1-15": "0",
        "16-31": "0"
      }
    }
  },
  "11": {
    "3": {
      "Jan": {
        "1-15": "24",
        "16-31": "24"
      },
      "Feb": {
        "1-15": "23",
        "16-31": "23"
      },
      "Mar": {
        "1-15": "22",
        "16-31": "21"
      },
      "Apr": {
        "1-15": "20",
        "16-31": "19"
      },
      "May": {
        "1-15": "17",
        "16-31": "15"
      },
      "Jun": {
        "1-15": "14",
        "16-31": "13"
      },
      "Jul": {
        "1-15": "11",
        "16-31": "10"
      },
      "Aug": {
        "1-15": "9",
        "16-31": "8"
      },
      "Sep": {
        "1-15": "7",
        "16-31": "6"
      },
      "Oct": {
        "1-15": "5",
        "16-31": "5"
      },
      "Nov": {
        "1-15": "4",
        "16-31": "4"
      },
      "Dec": {
        "1-15": "3",
        "16-31": "3"
      }
    },
    "4": {
      "Jan": {
        "1-15": "2",
        "16-31": "2"
      },
      "Feb": {
        "1-15": "1",
        "16-31": "1"
      },
      "Mar": {
        "1-15": "0",
        "16-31": "0"
      },
      "Apr": {
        "1-15": "0",
        "16-31": "0"
      },
      "May": {
        "1-15": "0",
        "16-31": "0"
      },
      "Jun": {
        "1-15": "0",
        "16-31": "0"
      },
      "Jul": {
        "1-15": "0",
        "16-31": "0"
      },
      "Aug": {
        "1-15": "0",
        "16-31": "0"
      },
      "Sep": {
        "1-15": "0",
        "16-31": "0"
      },
      "Oct": {
        "1-15": "0",
        "16-31": "0"
      },
      "Nov": {
        "1-15": "0",
        "16-31": "0"
      },
      "Dec": {
        "1-15": "0",
        "16-31": "0"
      }
    }
  },
  "12": {
    "3": {
      "Jan": {
        "1-15": "25",
        "16-31": "25"
      },
      "Feb": {
        "1-15": "24",
        "16-31": "24"
      },
      "Mar": {
        "1-15": "23",
        "16-31": "22"
      },
      "Apr": {
        "1-15": "21",
        "16-31": "20"
      },
      "May": {
        "1-15": "19",
        "16-31": "17"
      },
      "Jun": {
        "1-15": "15",
        "16-31": "14"
      },
      "Jul": {
        "1-15": "12",
        "16-31": "11"
      },
      "Aug": {
        "1-15": "10",
        "16-31": "9"
      },
      "Sep": {
        "1-15": "8",
        "16-31": "7"
      },
      "Oct": {
        "1-15": "6",
        "16-31": "6"
      },
      "Nov": {
        "1-15": "5",
        "16-31": "5"
      },
      "Dec": {
        "1-15": "4",
        "16-31": "4"
      }
    },
    "4": {
      "Jan": {
        "1-15": "3",
        "16-31": "3"
      },
      "Feb": {
        "1-15": "2",
        "16-31": "2"
      },
      "Mar": {
        "1-15": "1",
        "16-31": "1"
      },
      "Apr": {
        "1-15": "0",
        "16-31": "0"
      },
      "May": {
        "1-15": "0",
        "16-31": "0"
      },
      "Jun": {
        "1-15": "0",
        "16-31": "0"
      },
      "Jul": {
        "1-15": "0",
        "16-31": "0"
      },
      "Aug": {
        "1-15": "0",
        "16-31": "0"
      },
      "Sep": {
        "1-15": "0",
        "16-31": "0"
      },
      "Oct": {
        "1-15": "0",
        "16-31": "0"
      },
      "Nov": {
        "1-15": "0",
        "16-31": "0"
      },
      "Dec": {
        "1-15": "0",
        "16-31": "0"
      }
    }
  },
  "13": {
    "3": {
      "Jan": {
        "1-15": "26",
        "16-31": "26"
      },
      "Feb": {
        "1-15": "25",
        "16-31": "25"
      },
      "Mar": {
        "1-15": "24",
        "16-31": "23"
      },
      "Apr": {
        "1-15": "22",
        "16-31": "21"
      },
      "May": {
        "1-15": "20",
        "16-31": "19"
      },
      "Jun": {
        "1-15": "17",
        "16-31": "15"
      },
      "Jul": {
        "1-15": "13",
        "16-31": "11"
      },
      "Aug": {
        "1-15": "10",
        "16-31": "9"
      },
      "Sep": {
        "1-15": "8",
        "16-31": "7"
      },
      "Oct": {
        "1-15": "6",
        "16-31": "6"
      },
      "Nov": {
        "1-15": "5",
        "16-31": "5"
      },
      "Dec": {
        "1-15": "4",
        "16-31": "4"
      }
    },
    "4": {
      "Jan": {
        "1-15": "3",
        "16-31": "3"
      },
      "Feb": {
        "1-15": "2",
        "16-31": "2"
      },
      "Mar": {
        "1-15": "1",
        "16-31": "1"
      },
      "Apr": {
        "1-15": "0",
        "16-31": "0"
      },
      "May": {
        "1-15": "0",
        "16-31": "0"
      },
      "Jun": {
        "1-15": "0",
        "16-31": "0"
      },
      "Jul": {
        "1-15": "0",
        "16-31": "0"
      },
      "Aug": {
        "1-15": "0",
        "16-31": "0"
      },
      "Sep": {
        "1-15": "0",
        "16-31": "0"
      },
      "Oct": {
        "1-15": "0",
        "16-31": "0"
      },
      "Nov": {
        "1-15": "0",
        "16-31": "0"
      },
      "Dec": {
        "1-15": "0",
        "16-31": "0"
      }
    }
  },
  "14": {
    "3": {
      "Jan": {
        "1-15": "27",
        "16-31": "27"
      },
      "Feb": {
        "1-15": "26",
        "16-31": "26"
      },
      "Mar": {
        "1-15": "25",
        "16-31": "24"
      },
      "Apr": {
        "1-15": "23",
        "16-31": "22"
      },
      "May": {
        "1-15": "21",
        "16-31": "20"
      },
      "Jun": {
        "1-15": "18",
        "16-31": "16"
      },
      "Jul": {
        "1-15": "14",
        "16-31": "12"
      },
      "Aug": {
        "1-15": "11",
        "16-31": "10"
      },
      "Sep": {
        "1-15": "9",
        "16-31": "8"
      },
      "Oct": {
        "1-15": "7",
        "16-31": "7"
      },
      "Nov": {
        "1-15": "6",
        "16-31": "6"
      },
      "Dec": {
        "1-15": "5",
        "16-31": "5"
      }
    },
    "4": {
      "Jan": {
        "1-15": "4",
        "16-31": "4"
      },
      "Feb": {
        "1-15": "3",
        "16-31": "3"
      },
      "Mar": {
        "1-15": "2",
        "16-31": "2"
      },
      "Apr": {
        "1-15": "1",
        "16-31": "1"
      },
      "May": {
        "1-15": "0",
        "16-31": "0"
      },
      "Jun": {
        "1-15": "0",
        "16-31": "0"
      },
      "Jul": {
        "1-15": "0",
        "16-31": "0"
      },
      "Aug": {
        "1-15": "0",
        "16-31": "0"
      },
      "Sep": {
        "1-15": "0",
        "16-31": "0"
      },
      "Oct": {
        "1-15": "0",
        "16-31": "0"
      },
      "Nov": {
        "1-15": "0",
        "16-31": "0"
      },
      "Dec": {
        "1-15": "0",
        "16-31": "0"
      }
    }
  },
  "15": {
    "3": {
      "Jan": {
        "1-15": "28",
        "16-31": "28"
      },
      "Feb": {
        "1-15": "27",
        "16-31": "27"
      },
      "Mar": {
        "1-15": "26",
        "16-31": "25"
      },
      "Apr": {
        "1-15": "24",
        "16-31": "23"
      },
      "May": {
        "1-15": "22",
        "16-31": "21"
      },
      "Jun": {
        "1-15": "19",
        "16-31": "17"
      },
      "Jul": {
        "1-15": "15",
        "16-31": "13"
      },
      "Aug": {
        "1-15": "12",
        "16-31": "11"
      },
      "Sep": {
        "1-15": "10",
        "16-31": "9"
      },
      "Oct": {
        "1-15": "8",
        "16-31": "7"
      },
      "Nov": {
        "1-15": "6",
        "16-31": "6"
      },
      "Dec": {
        "1-15": "5",
        "16-31": "5"
      }
    },
    "4": {
      "Jan": {
        "1-15": "4",
        "16-31": "4"
      },
      "Feb": {
        "1-15": "3",
        "16-31": "3"
      },
      "Mar": {
        "1-15": "2",
        "16-31": "2"
      },
      "Apr": {
        "1-15": "1",
        "16-31": "1"
      },
      "May": {
        "1-15": "0",
        "16-31": "0"
      },
      "Jun": {
        "1-15": "0",
        "16-31": "0"
      },
      "Jul": {
        "1-15": "0",
        "16-31": "0"
      },
      "Aug": {
        "1-15": "0",
        "16-31": "0"
      },
      "Sep": {
        "1-15": "0",
        "16-31": "0"
      },
      "Oct": {
        "1-15": "0",
        "16-31": "0"
      },
      "Nov": {
        "1-15": "0",
        "16-31": "0"
      },
      "Dec": {
        "1-15": "0",
        "16-31": "0"
      }
    }
  },
  "16": {
    "3": {
      "Jan": {
        "1-15": "29",
        "16-31": "29"
      },
      "Feb": {
        "1-15": "28",
        "16-31": "28"
      },
      "Mar": {
        "1-15": "27",
        "16-31": "26"
      },
      "Apr": {
        "1-15": "25",
        "16-31": "24"
      },
      "May": {
        "1-15": "23",
        "16-31": "22"
      },
      "Jun": {
        "1-15": "21",
        "16-31": "19"
      },
      "Jul": {
        "1-15": "17",
        "16-31": "15"
      },
      "Aug": {
        "1-15": "13",
        "16-31": "12"
      },
      "Sep": {
        "1-15": "11",
        "16-31": "10"
      },
      "Oct": {
        "1-15": "9",
        "16-31": "8"
      },
      "Nov": {
        "1-15": "7",
        "16-31": "7"
      },
      "Dec": {
        "1-15": "6",
        "16-31": "6"
      }
    },
    "4": {
      "Jan": {
        "1-15": "5",
        "16-31": "5"
      },
      "Feb": {
        "1-15": "4",
        "16-31": "4"
      },
      "Mar": {
        "1-15": "3",
        "16-31": "3"
      },
      "Apr": {
        "1-15": "2",
        "16-31": "2"
      },
      "May": {
        "1-15": "1",
        "16-31": "1"
      },
      "Jun": {
        "1-15": "0",
        "16-31": "0"
      },
      "Jul": {
        "1-15": "0",
        "16-31": "0"
      },
      "Aug": {
        "1-15": "0",
        "16-31": "0"
      },
      "Sep": {
        "1-15": "0",
        "16-31": "0"
      },
      "Oct": {
        "1-15": "0",
        "16-31": "0"
      },
      "Nov": {
        "1-15": "0",
        "16-31": "0"
      },
      "Dec": {
        "1-15": "0",
        "16-31": "0"
      }
    }
  },
  "18": {
    "3": {
      "Jan": {
        "1-15": "31",
        "16-31": "31"
      },
      "Feb": {
        "1-15": "30",
        "16-31": "30"
      },
      "Mar": {
        "1-15": "29",
        "16-31": "28"
      },
      "Apr": {
        "1-15": "27",
        "16-31": "26"
      },
      "May": {
        "1-15": "25",
        "16-31": "24"
      },
      "Jun": {
        "1-15": "23",
        "16-31": "21"
      },
      "Jul": {
        "1-15": "19",
        "16-31": "17"
      },
      "Aug": {
        "1-15": "15",
        "16-31": "13"
      },
      "Sep": {
        "1-15": "12",
        "16-31": "11"
      },
      "Oct": {
        "1-15": "10",
        "16-31": "9"
      },
      "Nov": {
        "1-15": "8",
        "16-31": "7"
      },
      "Dec": {
        "1-15": "6",
        "16-31": "6"
      }
    },
    "4": {
      "Jan": {
        "1-15": "5",
        "16-31": "5"
      },
      "Feb": {
        "1-15": "4",
        "16-31": "4"
      },
      "Mar": {
        "1-15": "3",
        "16-31": "3"
      },
      "Apr": {
        "1-15": "2",
        "16-31": "2"
      },
      "May": {
        "1-15": "1",
        "16-31": "1"
      },
      "Jun": {
        "1-15": "0",
        "16-31": "0"
      },
      "Jul": {
        "1-15": "0",
        "16-31": "0"
      },
      "Aug": {
        "1-15": "0",
        "16-31": "0"
      },
      "Sep": {
        "1-15": "0",
        "16-31": "0"
      },
      "Oct": {
        "1-15": "0",
        "16-31": "0"
      },
      "Nov": {
        "1-15": "0",
        "16-31": "0"
      },
      "Dec": {
        "1-15": "0",
        "16-31": "0"
      }
    }
  },
  "20": {
    "3": {
      "Jan": {
        "1-15": "33",
        "16-31": "33"
      },
      "Feb": {
        "1-15": "32",
        "16-31": "32"
      },
      "Mar": {
        "1-15": "31",
        "16-31": "30"
      },
      "Apr": {
        "1-15": "29",
        "16-31": "28"
      },
      "May": {
        "1-15": "27",
        "16-31": "26"
      },
      "Jun": {
        "1-15": "25",
        "16-31": "23"
      },
      "Jul": {
        "1-15": "21",
        "16-31": "19"
      },
      "Aug": {
        "1-15": "17",
        "16-31": "15"
      },
      "Sep": {
        "1-15": "13",
        "16-31": "12"
      },
      "Oct": {
        "1-15": "11",
        "16-31": "10"
      },
      "Nov": {
        "1-15": "9",
        "16-31": "8"
      },
      "Dec": {
        "1-15": "7",
        "16-31": "7"
      }
    },
    "4": {
      "Jan": {
        "1-15": "6",
        "16-31": "6"
      },
      "Feb": {
        "1-15": "5",
        "16-31": "5"
      },
      "Mar": {
        "1-15": "4",
        "16-31": "4"
      },
      "Apr": {
        "1-15": "3",
        "16-31": "3"
      },
      "May": {
        "1-15": "2",
        "16-31": "2"
      },
      "Jun": {
        "1-15": "1",
        "16-31": "1"
      },
      "Jul": {
        "1-15": "0",
        "16-31": "0"
      },
      "Aug": {
        "1-15": "0",
        "16-31": "0"
      },
      "Sep": {
        "1-15": "0",
        "16-31": "0"
      },
      "Oct": {
        "1-15": "0",
        "16-31": "0"
      },
      "Nov": {
        "1-15": "0",
        "16-31": "0"
      },
      "Dec": {
        "1-15": "0",
        "16-31": "0"
      }
    }
  }
}

var wfaSteeplechase = {
  "16": {
    "4": {
      "Jan": {
        "1-15": "0",
        "16-31": "0"
      },
      "Feb": {
        "1-15": "0",
        "16-31": "0"
      },
      "Mar": {
        "1-15": "0",
        "16-31": "0"
      },
      "Apr": {
        "1-15": "0",
        "16-31": "0"
      },
      "May": {
        "1-15": "18",
        "16-31": "18"
      },
      "Jun": {
        "1-15": "17",
        "16-31": "17"
      },
      "Jul": {
        "1-15": "16",
        "16-31": "15"
      },
      "Aug": {
        "1-15": "14",
        "16-31": "13"
      },
      "Sep": {
        "1-15": "12",
        "16-31": "11"
      },
      "Oct": {
        "1-15": "10",
        "16-31": "9"
      },
      "Nov": {
        "1-15": "8",
        "16-31": "7"
      },
      "Dec": {
        "1-15": "6",
        "16-31": "5"
      }
    },
    "5": {
      "Jan": {
        "1-15": "4",
        "16-31": "3"
      },
      "Feb": {
        "1-15": "2",
        "16-31": "1"
      },
      "Mar": {
        "1-15": "0",
        "16-31": "0"
      },
      "Apr": {
        "1-15": "0",
        "16-31": "0"
      },
      "May": {
        "1-15": "0",
        "16-31": "0"
      },
      "Jun": {
        "1-15": "0",
        "16-31": "0"
      },
      "Jul": {
        "1-15": "0",
        "16-31": "0"
      },
      "Aug": {
        "1-15": "0",
        "16-31": "0"
      },
      "Sep": {
        "1-15": "0",
        "16-31": "0"
      },
      "Oct": {
        "1-15": "0",
        "16-31": "0"
      },
      "Nov": {
        "1-15": "0",
        "16-31": "0"
      },
      "Dec": {
        "1-15": "0",
        "16-31": "0"
      }
    }
  },
  "20": {
    "4": {
      "Jan": {
        "1-15": "0",
        "16-31": "0"
      },
      "Feb": {
        "1-15": "0",
        "16-31": "0"
      },
      "Mar": {
        "1-15": "0",
        "16-31": "0"
      },
      "Apr": {
        "1-15": "0",
        "16-31": "0"
      },
      "May": {
        "1-15": "19",
        "16-31": "19"
      },
      "Jun": {
        "1-15": "18",
        "16-31": "18"
      },
      "Jul": {
        "1-15": "17",
        "16-31": "16"
      },
      "Aug": {
        "1-15": "15",
        "16-31": "14"
      },
      "Sep": {
        "1-15": "13",
        "16-31": "12"
      },
      "Oct": {
        "1-15": "11",
        "16-31": "10"
      },
      "Nov": {
        "1-15": "9",
        "16-31": "8"
      },
      "Dec": {
        "1-15": "7",
        "16-31": "6"
      }
    },
    "5": {
      "Jan": {
        "1-15": "5",
        "16-31": "4"
      },
      "Feb": {
        "1-15": "3",
        "16-31": "2"
      },
      "Mar": {
        "1-15": "1",
        "16-31": "0"
      },
      "Apr": {
        "1-15": "0",
        "16-31": "0"
      },
      "May": {
        "1-15": "0",
        "16-31": "0"
      },
      "Jun": {
        "1-15": "0",
        "16-31": "0"
      },
      "Jul": {
        "1-15": "0",
        "16-31": "0"
      },
      "Aug": {
        "1-15": "0",
        "16-31": "0"
      },
      "Sep": {
        "1-15": "0",
        "16-31": "0"
      },
      "Oct": {
        "1-15": "0",
        "16-31": "0"
      },
      "Nov": {
        "1-15": "0",
        "16-31": "0"
      },
      "Dec": {
        "1-15": "0",
        "16-31": "0"
      }
    }
  },
  "24": {
    "4": {
      "Jan": {
        "1-15": "0",
        "16-31": "0"
      },
      "Feb": {
        "1-15": "0",
        "16-31": "0"
      },
      "Mar": {
        "1-15": "0",
        "16-31": "0"
      },
      "Apr": {
        "1-15": "0",
        "16-31": "0"
      },
      "May": {
        "1-15": "20",
        "16-31": "20"
      },
      "Jun": {
        "1-15": "19",
        "16-31": "19"
      },
      "Jul": {
        "1-15": "18",
        "16-31": "17"
      },
      "Aug": {
        "1-15": "16",
        "16-31": "15"
      },
      "Sep": {
        "1-15": "14",
        "16-31": "13"
      },
      "Oct": {
        "1-15": "12",
        "16-31": "11"
      },
      "Nov": {
        "1-15": "10",
        "16-31": "9"
      },
      "Dec": {
        "1-15": "8",
        "16-31": "7"
      }
    },
    "5": {
      "Jan": {
        "1-15": "6",
        "16-31": "5"
      },
      "Feb": {
        "1-15": "4",
        "16-31": "3"
      },
      "Mar": {
        "1-15": "2",
        "16-31": "1"
      },
      "Apr": {
        "1-15": "0",
        "16-31": "0"
      },
      "May": {
        "1-15": "0",
        "16-31": "0"
      },
      "Jun": {
        "1-15": "0",
        "16-31": "0"
      },
      "Jul": {
        "1-15": "0",
        "16-31": "0"
      },
      "Aug": {
        "1-15": "0",
        "16-31": "0"
      },
      "Sep": {
        "1-15": "0",
        "16-31": "0"
      },
      "Oct": {
        "1-15": "0",
        "16-31": "0"
      },
      "Nov": {
        "1-15": "0",
        "16-31": "0"
      },
      "Dec": {
        "1-15": "0",
        "16-31": "0"
      }
    }
  }
}

var wfaFlatNzl = {
  "5": {
    "2": {
      "Jan": { "1-15": "0", "16-31": "0" },
      "Feb": { "1-15": "0", "16-31": "0" },
      "Mar": { "1-15": "0", "16-31": "47" },
      "Apr": { "1-15": "44", "16-31": "41" },
      "May": { "1-15": "38", "16-31": "36" },
      "Jun": { "1-15": "34", "16-31": "32" },
      "Jul": { "1-15": "30", "16-31": "28" },
      "Aug": { "1-15": "26", "16-31": "24" },
      "Sep": { "1-15": "22", "16-31": "20" },
      "Oct": { "1-15": "19", "16-31": "18" },
      "Nov": { "1-15": "17", "16-31": "17" },
      "Dec": { "1-15": "16", "16-31": "16" }
    },
    "3": {
      "Jan": { "1-15": "15", "16-31": "15" },
      "Feb": { "1-15": "14", "16-31": "14" },
      "Mar": { "1-15": "13", "16-31": "12" },
      "Apr": { "1-15": "11", "16-31": "10" },
      "May": { "1-15": "9", "16-31": "8" },
      "Jun": { "1-15": "7", "16-31": "6" },
      "Jul": { "1-15": "5", "16-31": "4" },
      "Aug": { "1-15": "3", "16-31": "2" },
      "Sep": { "1-15": "1", "16-31": "1" },
      "Oct": { "1-15": "0", "16-31": "0" },
      "Nov": { "1-15": "0", "16-31": "0" },
      "Dec": { "1-15": "0", "16-31": "0" }
    }
  },
  "6": {
    "2": {
      "Jan": { "1-15": "0", "16-31": "0" },
      "Feb": { "1-15": "0", "16-31": "0" },
      "Mar": { "1-15": "0", "16-31": "0" },
      "Apr": { "1-15": "0", "16-31": "0" },
      "May": { "1-15": "44", "16-31": "41" },
      "Jun": { "1-15": "38", "16-31": "36" },
      "Jul": { "1-15": "33", "16-31": "31" },
      "Aug": { "1-15": "28", "16-31": "26" },
      "Sep": { "1-15": "24", "16-31": "22" },
      "Oct": { "1-15": "21", "16-31": "20" },
      "Nov": { "1-15": "19", "16-31": "18" },
      "Dec": { "1-15": "17", "16-31": "17" }
    },
    "3": {
      "Jan": { "1-15": "16", "16-31": "16" },
      "Feb": { "1-15": "15", "16-31": "15" },
      "Mar": { "1-15": "14", "16-31": "13" },
      "Apr": { "1-15": "12", "16-31": "11" },
      "May": { "1-15": "10", "16-31": "9" },
      "Jun": { "1-15": "8", "16-31": "7" },
      "Jul": { "1-15": "6", "16-31": "5" },
      "Aug": { "1-15": "4", "16-31": "3" },
      "Sep": { "1-15": "2", "16-31": "2" },
      "Oct": { "1-15": "1", "16-31": "1" },
      "Nov": { "1-15": "0", "16-31": "0" },
      "Dec": { "1-15": "0", "16-31": "0" }
    }
  },
  "7": {
    "2": {
      "Jan": { "1-15": "0", "16-31": "0" },
      "Feb": { "1-15": "0", "16-31": "0" },
      "Mar": { "1-15": "0", "16-31": "0" },
      "Apr": { "1-15": "0", "16-31": "0" },
      "May": { "1-15": "0", "16-31": "0" },
      "Jun": { "1-15": "0", "16-31": "0" },
      "Jul": { "1-15": "38", "16-31": "35" },
      "Aug": { "1-15": "32", "16-31": "30" },
      "Sep": { "1-15": "27", "16-31": "25" },
      "Oct": { "1-15": "23", "16-31": "22" },
      "Nov": { "1-15": "21", "16-31": "20" },
      "Dec": { "1-15": "19", "16-31": "19" }
    },
    "3": {
      "Jan": { "1-15": "18", "16-31": "18" },
      "Feb": { "1-15": "17", "16-31": "17" },
      "Mar": { "1-15": "16", "16-31": "15" },
      "Apr": { "1-15": "14", "16-31": "13" },
      "May": { "1-15": "12", "16-31": "11" },
      "Jun": { "1-15": "10", "16-31": "9" },
      "Jul": { "1-15": "8", "16-31": "7" },
      "Aug": { "1-15": "6", "16-31": "5" },
      "Sep": { "1-15": "4", "16-31": "3" },
      "Oct": { "1-15": "2", "16-31": "2" },
      "Nov": { "1-15": "1", "16-31": "1" },
      "Dec": { "1-15": "0", "16-31": "0" }
    }
  },
  "8": {
    "2": {
      "Jan": { "1-15": "0", "16-31": "0" },
      "Feb": { "1-15": "0", "16-31": "0" },
      "Mar": { "1-15": "0", "16-31": "0" },
      "Apr": { "1-15": "0", "16-31": "0" },
      "May": { "1-15": "0", "16-31": "0" },
      "Jun": { "1-15": "0", "16-31": "0" },
      "Jul": { "1-15": "0", "16-31": "0" },
      "Aug": { "1-15": "37", "16-31": "34" },
      "Sep": { "1-15": "31", "16-31": "28" },
      "Oct": { "1-15": "26", "16-31": "24" },
      "Nov": { "1-15": "23", "16-31": "22" },
      "Dec": { "1-15": "21", "16-31": "20" }
    },
    "3": {
      "Jan": { "1-15": "20", "16-31": "20" },
      "Feb": { "1-15": "19", "16-31": "19" },
      "Mar": { "1-15": "18", "16-31": "17" },
      "Apr": { "1-15": "15", "16-31": "14" },
      "May": { "1-15": "13", "16-31": "12" },
      "Jun": { "1-15": "11", "16-31": "10" },
      "Jul": { "1-15": "9", "16-31": "8" },
      "Aug": { "1-15": "7", "16-31": "6" },
      "Sep": { "1-15": "5", "16-31": "4" },
      "Oct": { "1-15": "3", "16-31": "3" },
      "Nov": { "1-15": "2", "16-31": "2" },
      "Dec": { "1-15": "1", "16-31": "1" }
    }
  },
  "9": {
    "3": {
      "Jan": { "1-15": "22", "16-31": "22" },
      "Feb": { "1-15": "21", "16-31": "21" },
      "Mar": { "1-15": "20", "16-31": "19" },
      "Apr": { "1-15": "17", "16-31": "15" },
      "May": { "1-15": "14", "16-31": "13" },
      "Jun": { "1-15": "12", "16-31": "11" },
      "Jul": { "1-15": "10", "16-31": "9" },
      "Aug": { "1-15": "8", "16-31": "7" },
      "Sep": { "1-15": "6", "16-31": "5" },
      "Oct": { "1-15": "4", "16-31": "4" },
      "Nov": { "1-15": "3", "16-31": "3" },
      "Dec": { "1-15": "2", "16-31": "2" }
    },
    "4": {
      "Jan": { "1-15": "1", "16-31": "1" },
      "Feb": { "1-15": "0", "16-31": "0" },
      "Mar": { "1-15": "0", "16-31": "0" },
      "Apr": { "1-15": "0", "16-31": "0" },
      "May": { "1-15": "0", "16-31": "0" },
      "Jun": { "1-15": "0", "16-31": "0" },
      "Jul": { "1-15": "0", "16-31": "0" },
      "Aug": { "1-15": "0", "16-31": "0" },
      "Sep": { "1-15": "0", "16-31": "0" },
      "Oct": { "1-15": "0", "16-31": "0" },
      "Nov": { "1-15": "0", "16-31": "0" },
      "Dec": { "1-15": "0", "16-31": "0" }
    }
  },
  "10": {
    "3": {
      "Jan": { "1-15": "23", "16-31": "23" },
      "Feb": { "1-15": "22", "16-31": "22" },
      "Mar": { "1-15": "21", "16-31": "20" },
      "Apr": { "1-15": "19", "16-31": "17" },
      "May": { "1-15": "15", "16-31": "14" },
      "Jun": { "1-15": "13", "16-31": "12" },
      "Jul": { "1-15": "10", "16-31": "9" },
      "Aug": { "1-15": "8", "16-31": "7" },
      "Sep": { "1-15": "6", "16-31": "5" },
      "Oct": { "1-15": "4", "16-31": "4" },
      "Nov": { "1-15": "3", "16-31": "3" },
      "Dec": { "1-15": "2", "16-31": "2" }
    },
    "4": {
      "Jan": { "1-15": "1", "16-31": "1" },
      "Feb": { "1-15": "0", "16-31": "0" },
      "Mar": { "1-15": "0", "16-31": "0" },
      "Apr": { "1-15": "0", "16-31": "0" },
      "May": { "1-15": "0", "16-31": "0" },
      "Jun": { "1-15": "0", "16-31": "0" },
      "Jul": { "1-15": "0", "16-31": "0" },
      "Aug": { "1-15": "0", "16-31": "0" },
      "Sep": { "1-15": "0", "16-31": "0" },
      "Oct": { "1-15": "0", "16-31": "0" },
      "Nov": { "1-15": "0", "16-31": "0" },
      "Dec": { "1-15": "0", "16-31": "0" }
    }
  },
  "11": {
    "3": {
      "Jan": { "1-15": "24", "16-31": "24" },
      "Feb": { "1-15": "23", "16-31": "23" },
      "Mar": { "1-15": "22", "16-31": "21" },
      "Apr": { "1-15": "20", "16-31": "19" },
      "May": { "1-15": "17", "16-31": "15" },
      "Jun": { "1-15": "14", "16-31": "13" },
      "Jul": { "1-15": "11", "16-31": "10" },
      "Aug": { "1-15": "9", "16-31": "8" },
      "Sep": { "1-15": "7", "16-31": "6" },
      "Oct": { "1-15": "5", "16-31": "5" },
      "Nov": { "1-15": "4", "16-31": "4" },
      "Dec": { "1-15": "3", "16-31": "3" }
    },
    "4": {
      "Jan": { "1-15": "2", "16-31": "2" },
      "Feb": { "1-15": "1", "16-31": "1" },
      "Mar": { "1-15": "0", "16-31": "0" },
      "Apr": { "1-15": "0", "16-31": "0" },
      "May": { "1-15": "0", "16-31": "0" },
      "Jun": { "1-15": "0", "16-31": "0" },
      "Jul": { "1-15": "0", "16-31": "0" },
      "Aug": { "1-15": "0", "16-31": "0" },
      "Sep": { "1-15": "0", "16-31": "0" },
      "Oct": { "1-15": "0", "16-31": "0" },
      "Nov": { "1-15": "0", "16-31": "0" },
      "Dec": { "1-15": "0", "16-31": "0" }
    }
  },
  "12": {
    "3": {
      "Jan": { "1-15": "25", "16-31": "25" },
      "Feb": { "1-15": "24", "16-31": "24" },
      "Mar": { "1-15": "23", "16-31": "22" },
      "Apr": { "1-15": "21", "16-31": "20" },
      "May": { "1-15": "19", "16-31": "17" },
      "Jun": { "1-15": "15", "16-31": "14" },
      "Jul": { "1-15": "12", "16-31": "11" },
      "Aug": { "1-15": "10", "16-31": "9" },
      "Sep": { "1-15": "8", "16-31": "7" },
      "Oct": { "1-15": "6", "16-31": "6" },
      "Nov": { "1-15": "5", "16-31": "5" },
      "Dec": { "1-15": "4", "16-31": "4" }
    },
    "4": {
      "Jan": { "1-15": "3", "16-31": "3" },
      "Feb": { "1-15": "2", "16-31": "2" },
      "Mar": { "1-15": "1", "16-31": "1" },
      "Apr": { "1-15": "0", "16-31": "0" },
      "May": { "1-15": "0", "16-31": "0" },
      "Jun": { "1-15": "0", "16-31": "0" },
      "Jul": { "1-15": "0", "16-31": "0" },
      "Aug": { "1-15": "0", "16-31": "0" },
      "Sep": { "1-15": "0", "16-31": "0" },
      "Oct": { "1-15": "0", "16-31": "0" },
      "Nov": { "1-15": "0", "16-31": "0" },
      "Dec": { "1-15": "0", "16-31": "0" }
    }
  },
  "13": {
    "3": {
      "Jan": { "1-15": "26", "16-31": "26" },
      "Feb": { "1-15": "25", "16-31": "25" },
      "Mar": { "1-15": "24", "16-31": "23" },
      "Apr": { "1-15": "22", "16-31": "21" },
      "May": { "1-15": "20", "16-31": "19" },
      "Jun": { "1-15": "17", "16-31": "15" },
      "Jul": { "1-15": "13", "16-31": "11" },
      "Aug": { "1-15": "10", "16-31": "9" },
      "Sep": { "1-15": "8", "16-31": "7" },
      "Oct": { "1-15": "6", "16-31": "6" },
      "Nov": { "1-15": "5", "16-31": "5" },
      "Dec": { "1-15": "4", "16-31": "4" }
    },
    "4": {
      "Jan": { "1-15": "3", "16-31": "3" },
      "Feb": { "1-15": "2", "16-31": "2" },
      "Mar": { "1-15": "1", "16-31": "1" },
      "Apr": { "1-15": "0", "16-31": "0" },
      "May": { "1-15": "0", "16-31": "0" },
      "Jun": { "1-15": "0", "16-31": "0" },
      "Jul": { "1-15": "0", "16-31": "0" },
      "Aug": { "1-15": "0", "16-31": "0" },
      "Sep": { "1-15": "0", "16-31": "0" },
      "Oct": { "1-15": "0", "16-31": "0" },
      "Nov": { "1-15": "0", "16-31": "0" },
      "Dec": { "1-15": "0", "16-31": "0" }
    }
  },
  "14": {
    "3": {
      "Jan": { "1-15": "27", "16-31": "27" },
      "Feb": { "1-15": "26", "16-31": "26" },
      "Mar": { "1-15": "25", "16-31": "24" },
      "Apr": { "1-15": "23", "16-31": "22" },
      "May": { "1-15": "21", "16-31": "20" },
      "Jun": { "1-15": "18", "16-31": "16" },
      "Jul": { "1-15": "14", "16-31": "12" },
      "Aug": { "1-15": "11", "16-31": "10" },
      "Sep": { "1-15": "9", "16-31": "8" },
      "Oct": { "1-15": "7", "16-31": "7" },
      "Nov": { "1-15": "6", "16-31": "6" },
      "Dec": { "1-15": "5", "16-31": "5" }
    },
    "4": {
      "Jan": { "1-15": "4", "16-31": "4" },
      "Feb": { "1-15": "3", "16-31": "3" },
      "Mar": { "1-15": "2", "16-31": "2" },
      "Apr": { "1-15": "1", "16-31": "1" },
      "May": { "1-15": "0", "16-31": "0" },
      "Jun": { "1-15": "0", "16-31": "0" },
      "Jul": { "1-15": "0", "16-31": "0" },
      "Aug": { "1-15": "0", "16-31": "0" },
      "Sep": { "1-15": "0", "16-31": "0" },
      "Oct": { "1-15": "0", "16-31": "0" },
      "Nov": { "1-15": "0", "16-31": "0" },
      "Dec": { "1-15": "0", "16-31": "0" }
    }
  },
  "15": {
    "3": {
      "Jan": { "1-15": "28", "16-31": "28" },
      "Feb": { "1-15": "27", "16-31": "27" },
      "Mar": { "1-15": "26", "16-31": "25" },
      "Apr": { "1-15": "24", "16-31": "23" },
      "May": { "1-15": "22", "16-31": "21" },
      "Jun": { "1-15": "19", "16-31": "17" },
      "Jul": { "1-15": "15", "16-31": "13" },
      "Aug": { "1-15": "12", "16-31": "11" },
      "Sep": { "1-15": "10", "16-31": "9" },
      "Oct": { "1-15": "8", "16-31": "7" },
      "Nov": { "1-15": "6", "16-31": "6" },
      "Dec": { "1-15": "5", "16-31": "5" }
    },
    "4": {
      "Jan": { "1-15": "4", "16-31": "4" },
      "Feb": { "1-15": "3", "16-31": "3" },
      "Mar": { "1-15": "2", "16-31": "2" },
      "Apr": { "1-15": "1", "16-31": "1" },
      "May": { "1-15": "0", "16-31": "0" },
      "Jun": { "1-15": "0", "16-31": "0" },
      "Jul": { "1-15": "0", "16-31": "0" },
      "Aug": { "1-15": "0", "16-31": "0" },
      "Sep": { "1-15": "0", "16-31": "0" },
      "Oct": { "1-15": "0", "16-31": "0" },
      "Nov": { "1-15": "0", "16-31": "0" },
      "Dec": { "1-15": "0", "16-31": "0" }
    }
  },
  "16": {
    "3": {
      "Jan": { "1-15": "29", "16-31": "29" },
      "Feb": { "1-15": "28", "16-31": "28" },
      "Mar": { "1-15": "27", "16-31": "26" },
      "Apr": { "1-15": "25", "16-31": "24" },
      "May": { "1-15": "23", "16-31": "22" },
      "Jun": { "1-15": "21", "16-31": "19" },
      "Jul": { "1-15": "17", "16-31": "15" },
      "Aug": { "1-15": "13", "16-31": "12" },
      "Sep": { "1-15": "11", "16-31": "10" },
      "Oct": { "1-15": "9", "16-31": "8" },
      "Nov": { "1-15": "7", "16-31": "7" },
      "Dec": { "1-15": "6", "16-31": "6" }
    },
    "4": {
      "Jan": { "1-15": "5", "16-31": "5" },
      "Feb": { "1-15": "4", "16-31": "4" },
      "Mar": { "1-15": "3", "16-31": "3" },
      "Apr": { "1-15": "2", "16-31": "2" },
      "May": { "1-15": "1", "16-31": "1" },
      "Jun": { "1-15": "0", "16-31": "0" },
      "Jul": { "1-15": "0", "16-31": "0" },
      "Aug": { "1-15": "0", "16-31": "0" },
      "Sep": { "1-15": "0", "16-31": "0" },
      "Oct": { "1-15": "0", "16-31": "0" },
      "Nov": { "1-15": "0", "16-31": "0" },
      "Dec": { "1-15": "0", "16-31": "0" }
    }
  },
  "18": {
    "3": {
      "Jan": { "1-15": "31", "16-31": "31" },
      "Feb": { "1-15": "30", "16-31": "30" },
      "Mar": { "1-15": "29", "16-31": "28" },
      "Apr": { "1-15": "27", "16-31": "26" },
      "May": { "1-15": "25", "16-31": "24" },
      "Jun": { "1-15": "23", "16-31": "21" },
      "Jul": { "1-15": "19", "16-31": "17" },
      "Aug": { "1-15": "15", "16-31": "13" },
      "Sep": { "1-15": "12", "16-31": "11" },
      "Oct": { "1-15": "10", "16-31": "9" },
      "Nov": { "1-15": "8", "16-31": "7" },
      "Dec": { "1-15": "6", "16-31": "6" }
    },
    "4": {
      "Jan": { "1-15": "5", "16-31": "5" },
      "Feb": { "1-15": "4", "16-31": "4" },
      "Mar": { "1-15": "3", "16-31": "3" },
      "Apr": { "1-15": "2", "16-31": "2" },
      "May": { "1-15": "1", "16-31": "1" },
      "Jun": { "1-15": "0", "16-31": "0" },
      "Jul": { "1-15": "0", "16-31": "0" },
      "Aug": { "1-15": "0", "16-31": "0" },
      "Sep": { "1-15": "0", "16-31": "0" },
      "Oct": { "1-15": "0", "16-31": "0" },
      "Nov": { "1-15": "0", "16-31": "0" },
      "Dec": { "1-15": "0", "16-31": "0" }
    }
  },
  "20": {
    "3": {
      "Jan": { "1-15": "33", "16-31": "33" },
      "Feb": { "1-15": "32", "16-31": "32" },
      "Mar": { "1-15": "31", "16-31": "30" },
      "Apr": { "1-15": "29", "16-31": "28" },
      "May": { "1-15": "27", "16-31": "26" },
      "Jun": { "1-15": "25", "16-31": "23" },
      "Jul": { "1-15": "21", "16-31": "19" },
      "Aug": { "1-15": "17", "16-31": "15" },
      "Sep": { "1-15": "13", "16-31": "12" },
      "Oct": { "1-15": "11", "16-31": "10" },
      "Nov": { "1-15": "9", "16-31": "8" },
      "Dec": { "1-15": "7", "16-31": "7" }
    },
    "4": {
      "Jan": { "1-15": "6", "16-31": "6" },
      "Feb": { "1-15": "5", "16-31": "5" },
      "Mar": { "1-15": "4", "16-31": "4" },
      "Apr": { "1-15": "3", "16-31": "3" },
      "May": { "1-15": "2", "16-31": "2" },
      "Jun": { "1-15": "1", "16-31": "1" },
      "Jul": { "1-15": "0", "16-31": "0" },
      "Aug": { "1-15": "0", "16-31": "0" },
      "Sep": { "1-15": "0", "16-31": "0" },
      "Oct": { "1-15": "0", "16-31": "0" },
      "Nov": { "1-15": "0", "16-31": "0" },
      "Dec": { "1-15": "0", "16-31": "0" }
    }
  }
}

exports.wfa = {
  "FLAT": wfaFlat,
  "JUMP": wfaJump,
  "STEEPLECHASE": wfaSteeplechase,
  "NZL_FLAT": wfaFlatNzl,
};